import { FC, memo, useMemo } from "react";
import { getTeamColors } from "components/colors";
import { MatchStatus } from "service";
import { Text } from "components/common/Text";

export const VolleyballScoreBoard: FC<{ status: MatchStatus }> = memo(
  ({ status }) => {
    const { home: homeColor, away: awayColor } = getTeamColors(status);

    const getPair = (v: any): [number, number] | null => {
      if (Array.isArray(v) && v.length >= 2) {
        const a = Number(v[0]) || 0;
        const b = Number(v[1]) || 0;
        return [a, b];
      }
      return null;
    };

    const { currentSetPoints, setsWon } = useMemo(() => {
      const c = (status as any)?.c ?? {};
      const pc: number | undefined =
        typeof (status as any)?.pc === "number"
          ? (status as any).pc
          : undefined;

      const setKeys = ["S1", "S2", "S3", "S4", "S5"];
      let current: [number, number] = [0, 0];

      if (pc && pc >= 1 && pc <= 5) {
        const byPc = getPair(c[`S${pc}`]);
        if (byPc) current = byPc;
      }
      if (current[0] === 0 && current[1] === 0) {
        for (let i = setKeys.length - 1; i >= 0; i--) {
          const p = getPair(c[setKeys[i]]);
          if (p) {
            current = p;
            break;
          }
        }
      }

      let sets: [number, number] | null = null;
      const t = getPair(c?.T);
      if (t && t[0] <= 5 && t[1] <= 5) sets = t;

      if (!sets) {
        let hs = 0;
        let as = 0;
        for (const k of setKeys) {
          const p = getPair(c[k]);
          if (p && (p[0] !== 0 || p[1] !== 0)) {
            if (p[0] > p[1]) hs += 1;
            else if (p[1] > p[0]) as += 1;
          }
        }
        sets = [hs, as];
      }

      return { currentSetPoints: current, setsWon: sets as [number, number] };
    }, [status]);

    const [homePts, awayPts] = currentSetPoints;
    const [homeSets, awaySets] = setsWon;

    return (
      <div className="absolute left-1/2 top-0 flex w-[11vw] -translate-x-1/2 flex-col items-stretch gap-[0.2vw]">
        <div className="grid h-[6vw] grid-cols-2 gap-[0.2vw]">
          <div className="grid grid-rows-[1vw,1fr] bg-white">
            <div
              className="h-[1vw] w-full border-b-[0.2vw] border-[#232343]"
              style={{
                backgroundColor: homeColor,
              }}
            />
            <div className="flex items-center justify-center font-extrabold text-black">
              <Text variant="volleyballScoreboard">{homePts}</Text>
            </div>
          </div>

          <div className="grid grid-rows-[1vw,1fr] bg-white">
            <div
              className="h-[1vw] w-full border-b-[0.2vw] border-[#232343]"
              style={{
                backgroundColor: awayColor,
              }}
            />
            <div className="flex items-center justify-center font-extrabold text-black">
              <Text variant="volleyballScoreboard">{awayPts}</Text>
            </div>
          </div>
        </div>

        <div className="flex h-[4vw] items-center justify-center bg-black/90 font-extrabold text-white">
          <Text variant="volleyballSets">
            {homeSets}-{awaySets}
          </Text>
        </div>
      </div>
    );
  }
);
